import type { BatMetadataConfigEntry } from './common/types';
import { coreFields } from './common/coreFields';
import { genericUnitField } from './common/sharedFields';
import { locationFields } from './common/locationFields';
import { vendorFields } from './common/vendorFields';
import {
  productCategoryField,
  productFields,
  productQuantityField,
} from './common/productFields';
import { msg } from '@lingui/core/macro';

export const soldRetailGoodMetadata = {
  displayName: msg({
    message: 'Sold products: Retail',
    context: 'Activity data schema name for sold retail goods',
  }),
  fields: {
    ...coreFields,
    ...locationFields,
    ...vendorFields,
    ...productFields,
    is_energy_star: {
      displayName: msg({
        message: 'Energy Star certified',
        context:
          'Indicator of whether the good sold is an Energy Star product.',
      }),
      externalDescription: msg({
        message:
          'Indicator of whether the good sold is an Energy Star product.',
        context: 'Energy Star certified',
      }),
    },
    product_category: productCategoryField,
    quantity: productQuantityField,
    unit: genericUnitField,
  },
} as const satisfies BatMetadataConfigEntry;
